<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
        <div>
          <div>
            <label style="width: 100%">
              <b-row style="width: 100%">
                <b-col cols="6">Paciente:
                  <validacion/>
                </b-col>
                <b-col cols="6" align="right"></b-col>
              </b-row>
            </label>
            <b-form-group id="paciente-fg-agr-cita">
              <b-input-group id="paciente-ig-agr-cita">
                <template v-slot:append>
                  <b-button
                      v-if="mostrarBusquedaPaciente && tipoBusqueda !== 2"
                      variant="outline-primary"
                      @click="llenarPacientesClinica()"
                  >
                    <b-icon class="searchicon" icon="search"></b-icon>
                  </b-button>
                  <b-button
                      v-if="!mostrarBusquedaPaciente"
                      variant="outline-warning"
                      :disabled="secondReagendar"
                      @click="limpiarPacienteSeleccionado"
                  >
                    <b-icon icon="trash-fill"></b-icon>
                  </b-button>
                </template>
                <b-form-input

                    v-if="
                mostrarBusquedaPaciente &&
                (tipoBusqueda === undefined ||
                  tipoBusqueda === null ||
                  tipoBusqueda === 1)
              "
                    v-model="datosFormulario.nombrePacienteBusqueda"
                    placeholder="Ingresa un nombre"
                    type="text"
                    v-on:keypress="esLetra($event)"
                    v-b-tooltip.hover
                    title="Búsqueda básica por nombre completo del paciente"
                    @keydown.enter.prevent="llenarPacientesClinica()"
                ></b-form-input>
                <!--                      Busqueda avanzada                               -->
                <div  v-if="mostrarBusquedaPaciente && tipoBusqueda === 2">
                  <br>
                  <b-row>
                    <b-col cols="col-sm-12 col-md-3 col-lg-3">
                      <b-form-input
                          style="width: 100%"
                          v-model="nombre"
                          placeholder=" nombre"
                          type="text"
                          v-on:keypress="esLetra($event)"
                          v-b-tooltip.hover
                          title="Búsqueda básica por nombre del paciente"
                          v-on:keyup.enter="getPatientsV2()"
                          class="input-buscador"
                      ></b-form-input>
                    </b-col>
                    <b-col cols="col-sm-12 col-md-3 col-lg-3">
                      <b-form-input
                          style="width: 100%"
                          v-model="apellidoPaterno"
                          placeholder="apellido paterno"
                          type="text"
                          v-on:keypress="esLetra($event)"
                          v-b-tooltip.hover
                          title="Apellido Paterno"
                          v-on:keyup.enter="getPatientsV2()"
                          class="input-buscador"
                      ></b-form-input>
                    </b-col>
                    <b-col cols="col-sm-12 col-md-3 col-lg-3">
                      <b-form-input
                          style="width: 100%"
                          v-model="apellidoMaterno"
                          placeholder="apellido materno"
                          type="text"
                          v-on:keypress="esLetra($event)"
                          v-b-tooltip.hover
                          title="Apellido Materno"
                          v-on:keyup.enter="getPatientsV2()"
                          class="input-buscador"
                      ></b-form-input>
                    </b-col>
                    <b-col cols="col-sm-12 col-md-1 col-lg-1">
                      <b-button size="sm"
                                v-if="datosCita == null"
                                variant="info"
                                style="margin: auto;"
                                @click="getPatientsV2()">
                        <span ><em class="buscar_svg" style="height: 16px;"></em></span>
                      </b-button>
                    </b-col>
                  </b-row>
                </div>
                <b-form-input
                    v-if="mostrarBusquedaPaciente && tipoBusqueda === 3"
                    v-model="datosFormulario.nombrePacienteBusqueda"
                    :min="0"
                    placeholder="Ingresa un ID de PX"
                    type="number"
                    v-b-tooltip.hover
                    title="Id del paciente"
                    @keydown.enter.prevent="llenarPacientesClinica()"
                ></b-form-input>
                <b-form-input
                    v-if="!mostrarBusquedaPaciente"
                    disabled
                    required
                    v-model="datosFormulario.nombrePaciente"
                    placeholder="Selecciona un paciente de los resultados"
                    type="text"
                    v-on:keypress="esLetra($event)"
                ></b-form-input>
              </b-input-group>
              <b-form-group v-slot="{ ariaDescribedbyTipoBusqueda }">
                <div class="centrar">
                  <b-form-radio-group
                      id="btn-tipos_busqueda_paciente"
                      v-model="tipoBusqueda"
                      :options="[
                                { text: 'Búsq. normal', value: 1 },
                                { text: 'Búsq. avanzada', value: 2 },
                                { text: 'Búsq. ID', value: 3 },
                              ]"
                      :aria-describedby="ariaDescribedbyTipoBusqueda"
                      button-variant="outline-primary"
                      size="sm"
                      name="radio-btn-outline"
                  ></b-form-radio-group>
                </div>
              </b-form-group>

              <b-container class="bv-example-row">
                <b-row>
                  <div class="centrar">
                    <b-col cols="10">
                      <b-spinner small v-if="loadingPacientes"/>
                      <span
                          class="tablePatients"
                          v-if="
                      !loadingPacientes &&
                      mostrarBusquedaPaciente &&
                      listaPacientes.length > 0
                    "
                          column="3"
                      >
                    <div class="mt-2 col-md-12"></div>
                    <b-table
                        thead-tr-class="columnas"
                        :items="listaPacientes"
                        :fields="encabezados"
                        :per-page="registrosPorPagina"
                        :current-page="paginaActual"
                        :hover="true"
                        :small="true"
                        @row-clicked="setearPaciente"
                        class="parrafos"
                        responsive
                        fixed
                    >
                      <template v-slot:cell(id)="row">
                        <span>{{ row.item.id }}</span>
                      </template>
                      <template v-slot:cell(name)="row">
                        <div class="spanCien">
                          <span>
                            {{
                              row.item.esPacienteNuevo ? "*" : ""
                            }}{{ row.item.name }}
                          </span>
                        </div>
                      </template>
                      <template v-slot:cell(saldo)="row">
                        {{ row.item.saldo }}
                      </template>
                      <template v-slot:cell(plan)="row">
                        <span>
                          {{ plan.nombre }}
                        </span>
                      </template>
                    </b-table>
                    <b-pagination
                        v-if="listaPacientes.length > 15"
                        align="center"
                        v-model="paginaActual"
                        :total-rows="listaPacientes.length"
                        :per-page="registrosPorPagina"
                    ></b-pagination>
                  </span>
                    </b-col>
                  </div>
                </b-row>
              </b-container>
            </b-form-group>
          </div>


        </div>
        <b-row>
          <b-col>
            <validation-provider
                :rules="{ required: true }"
                v-slot="errors"
                v-if="!secondReagendar"
            >
              <label>Teléfono</label>
              <validacion/>
              <v-select v-if="datosFormulario.telefono !== 'null'"
                  disabled
                  label="telefono"
                  placeholder="Selecciona un teléfono"
                  v-model="datosFormulario.telefono"

              >
              </v-select>
              <v-select v-else
                        disabled
                        label="telefono"
                        placeholder="No hay contacto"
              >
              </v-select>
            </validation-provider>
          </b-col>
          <b-col>
            <validation-provider
                :rules="{ required: true }"
                v-slot="errors"
                v-if="!secondReagendar"
            >
              <label>Correo</label>
              <validacion/>
              <v-select v-if="datosFormulario.correo !== 'null'"
                  disabled
                  label="correo"
                  placeholder="Selecciona un correo"
                  v-model="datosFormulario.correo"
              >
                  <span slot="no-options"
                  >No hay correos disponibles</span
                  >
              </v-select>
              <v-select v-else
                  disabled
                  label="correo"
                  placeholder="No hay correo"
              >
              </v-select>
            </validation-provider>
          </b-col>
        </b-row>

        <div class="mt-4">
          <validation-provider
              :rules="{ required: true }"
              v-slot="errors"
          >
            <label>Doctor</label>
            <validacion/>
            <b-form-group>
              <v-select
                  :options="listaDoctoresFiltro"
                  :filterable="false"
                  v-model="datosFormulario.idDoctor"
                  :reduce="(variable) => variable.id"
                  label="nombre"
                  placeholder="Selecciona un doctor (*)"
                  @search="filtroDoctores"
                  @input="llenarEspecialidadesDoctor(true)"
              >
            <span slot="no-options"
            >No hay doctores disponibles</span
            >
              </v-select>
              <validacion
                  :texto="errors.errors[0] ? errors.errors[0] : ' '"
              />
            </b-form-group>
          </validation-provider>
        </div>

        <b-row class="mt-4">
          <b-col>
            <validation-provider
                :rules="{ required: true }"
                v-slot="errors"
                v-if="!secondReagendar"
            >
              <label>Especialidad</label>
              <validacion/>
              <v-select
                  id="idEspecialidad"
                  label="nombre"
                  placeholder="Selecciona una especialidad"
                  :options="listaEspecialidadesDoctor"
                  v-model="datosFormulario.idEspecialidad"
                  :reduce="(variable) => variable.id"
                  @input="llenarTratamientos()"
              >
                  <span slot="no-options"
                  >No hay especialidad disponibles</span
                  >
              </v-select>
            </validation-provider>
          </b-col>
          <b-col>
            <validation-provider
                :rules="{ required: true }"
                v-slot="errors"
                v-if="!secondReagendar"
            >
              <label>Tratamiento</label>
              <validacion/>
              <v-select
                  id="idTratamiento"
                  label="nombre"
                  :options="listaTratamientos"
                  v-model="datosFormulario.idTratamiento"
                  :reduce="(variable) => variable.id"
                  placeholder="Selecciona un tratamiento"
              >
                  <span slot="no-options"
                  >No hay tratamientos disponibles</span
                  >
              </v-select>
            </validation-provider>
          </b-col>
        </b-row>

        <b-row class="mt-4">
          <b-col>
            <validation-provider
                :rules="{ required: true }"
                v-slot="errors"
            >
              <label>Motivo</label>
              <validacion/>
              <v-select
                  style="width: 100%;  border:2px solid;
                border-color: #aceaf4;
                border-radius: 8px; "
                  label="descripcion"
                  :options="listaMotivo"
                  placeholder="Selecciona un motivo"
                  v-model="datosFormulario.idMotivoEspera"
                  :reduce="(item) => item.id"
              >
                <span slot="no-options">No hay motivos disponibles</span>
              </v-select>
            </validation-provider>
          </b-col>
        </b-row>

    <b-row class="mt-4">
      <b-col>
        <validation-provider
            :rules="{ required: true }"
            v-slot="errors"
        >
          <label>Motivo de cita</label>
          <validacion/>
          <v-select
              :options="tagmotivocitaDatosArrayFiltro"
              :filterable="false"
              @search="filtrotagmotivocitaDatos"
              v-model="datosFormulario.idTagMotivoCita"
              :reduce="(variable) => variable.idTagMotivoCita"
              label="descripcionTagMotivoCita"
              placeholder="Selecciona un motivo de cíta"
              @input="setearMotivoTag($event)"
          >
                        <span slot="no-options"
                        >No hay motivos de cíta disponibles</span
                        >
          </v-select>
        </validation-provider>
      </b-col>
    </b-row>

        <b-row class="mt-4">
          <b-col>
            <validation-provider
                :rules="{ required: true }"
                v-slot="errors"
            >
              <label>Fecha inicio de cita solicitada</label>
              <validacion/>
              <b-form-group>
                <b-spinner small v-if="loadingFechaInicioCitaSoli"/>
                <b-form-datepicker
                    id="fechacita-datepicker"
                    labelNoDateSelected="Fecha inicio de cita solicitada"
                    v-model="datosFormulario.fechaInicio"
                    range
                    class="mb-2"
                    :min="fechaMinima"
                    in
                    no-flip
                ></b-form-datepicker>
                <validacion
                    :texto="errors.errors[0] ? errors.errors[0] : ' '"
                />
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col>
            <validation-provider
                :rules="{ required: true }"
                v-slot="errors"
            >
              <label>Fecha fin de cita Solicitada</label>
              <validacion/>
              <b-form-group>
                <b-spinner small v-if="loadingFechaFinCitaSoli"/>
                <b-form-datepicker
                    id="fechacitafin-datepicker"
                    labelNoDateSelected="Fecha fin de cita Solicitada"
                    v-model="datosFormulario.fechaFin"
                    range
                    class="mb-2"
                    :min="fechaMinima"
                    in
                    no-flip
                ></b-form-datepicker>
                <validacion
                    :texto="errors.errors[0] ? errors.errors[0] : ' '"
                />
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
        <b-row class="mt-4">

          <b-col>
            <b-form-group align="left">
              <label>Dias de exclusión:</label>
              <v-select
                  style="width: 100%"
                  name="dia"
                  placeholder="--Seleccionar--"
                  label="descripcion"
                  multiple
                  :options="listaDias"
                  :reduce="(variable) => variable.id"
                  v-model="datosFormulario.dias"
              ><span slot="no-options">No hay dias disponibles</span>
              </v-select>
            </b-form-group>
            <b-form-invalid-feedback
                :state="datosFormulario.dias!= null && datosFormulario.dias.length > 0"
            >
              Este campo es obligatorio
            </b-form-invalid-feedback>
          </b-col>
        </b-row>
        <b-row class="mt-4 text-center">
          <b-col>
            <validation-provider
                :rules="{ required: true }"
                v-slot="errors"
            >
              <label>Hora inicio</label>
              <validacion/>
              <b-form-group>
                <vue-timepicker
                    id="idHoraInicio"
                    v-model="datosFormulario.horaInicio"
                    hide-disabled-items
                    format="HH:mm"
                    :minute-interval="15"
                    :hour-range="rangoHoraForm"
                    hide-clear-button
                ></vue-timepicker>

                <validacion
                    :texto="errors.errors[0] ? errors.errors[0] : ' '"
                />
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col>
            <validation-provider
                :rules="{ required: true }"
                v-slot="errors"
            >
              <label>Hora fin</label>
              <validacion/>
              <b-form-group>
                <vue-timepicker
                    id="idHoraFin"
                    v-model="datosFormulario.horaFin"
                    hide-disabled-items
                    format="HH:mm"
                    :minute-interval="15"
                    :hour-range="rangoHoraForm"
                    hide-clear-button
                ></vue-timepicker>

                <validacion
                    :texto="errors.errors[0] ? errors.errors[0] : ' '"
                />
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12" v-if="rangoHoraClinica !== undefined">
            Horario(s) Clinica:
            <b-badge v-for="hc in rangoHoraClinica" v-bind:key="hc">{{
                hc
              }}
            </b-badge>
          </b-col>
          <b-col cols="12" v-else>
            <validacion
                texto="Tu clinica no cuenta con ningún horario"
            />
          </b-col>

          <div>
            <b-col
                cols="12"
                v-if="!rangoHoraFormEsValido"
            >
              <validacion texto="Selecciona un horario válido"/>
            </b-col>
          </div>
        </b-row>
        <b-row class="mt-4">
          <b-col>
            <div class="mt-3 col-md-12"></div>

            <validation-provider
                :rules="{ required: true }"
                v-slot="errors"
            >
              <label>Observaciones</label>
              <validacion/>
              <b-form-group>
                <b-form-textarea
                    id="idObservaciones"
                    v-model="datosFormulario.comentario"
                    placeholder="Introduce tus observaciones"
                    rows="3"
                    max-rows="6"
                ></b-form-textarea>
                <validacion
                    :texto="errors.errors[0] ? errors.errors[0] : ' '"
                />
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>

    <div class="mt-2 col-12 d-flex justify-content-center">
      <div class="d-flex justify-content-center"  v-if="datosFormulario.esPacienteVIP">
        <em class="mr-2"  v-b-tooltip.hover.top.v-light
            title="Este Paciente es MISD"
            aria-label="Paciente MISD">
          <font-awesome-icon :icon="['fas', 'crown']" size="md" style="color: #FFD43B;" />
        </em>
        <span>EL PACIENTE AL QUE SE LE ASIGNARÁ LA CITA ES MISD</span>
      </div>
    </div>

    <div style="position: initial; margin-left: 70%;">
          <b-button variant="outline-primary" @click="llenarDatosListaEspera"
          >Aceptar
          </b-button
          >
          <b-button
              variant="outline-danger"
              @click="showDialogEnviaListEsperaDatos = false;"
          >Cancelar
          </b-button>
    </div>
  </div>
</template>

<script>
import miniToastr from "mini-toastr";

export default {
  name: "EnviarAListaEsperaCalendario",
  props:{
    mostrarBusquedaPaciente: Boolean,
    datosFormulario: null,
    listaPacientes: Array,
    loadingPacientes: Boolean,
    secondReagendar: Boolean,
    listaDias: Array,
    fechaMinima: null,
    rangoHoraForm: null,
    rangoHoraClinica: null,
    rangoHoraFormEsValido: null,
    listaDoctores: Array,
    listaDoctoresFiltro: Array,
    loadingFechaFinCitaPerdida: Boolean,
    listaEspecialidadesDoctor: Array,
    listaTratamientos: Array,
    listaMotivo: Array,
    loadingFechaInicioCitaSoli: Boolean,
    loadingFechaFinCitaSoli: Boolean,
    tagmotivocitaDatosArrayFiltro: Array,
    filtrotagmotivocitaDatos: null,
  },
  data:()=> ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    tipoBusqueda: 1,
    encabezados: [
      {
        key: "id",
        label: "Id",
      },
      {
        key: "name",
        label: "Nombre del Paciente",
      },
    ],
    registrosPorPagina: 15,
    paginaActual: 1,
    nombre: "",
    apellidoPaterno: "",
    apellidoMaterno: "",
}),
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {
    llenarPacientesClinica(){
      this.$emit('llenarPacientesClinica', this.tipoBusqueda);
    },
    llenarEspecialidadesDoctor(){
      this.$emit('llenarEspecialidadesDoctor');
    },
    llenarTratamientos(){
      this.$emit('llenarTratamientos');
    },
    limpiarPacienteSeleccionado(){
      this.$emit('limpiarPacienteSeleccionado');
    },

    llenarDatosListaEspera() {

        let datos = {
          idMotivoEspera: this.datosFormulario.idMotivoEspera,
          idPaciente: this.datosFormulario.idPaciente,
          comentario: this.datosFormulario.comentario,
          fechaFin: new Date(this.datosFormulario.fechaFin),
          fechaInicio: new Date(this.datosFormulario.fechaInicio),
          horafin: this.datosFormulario.horaFin.HH + this.datosFormulario.horaFin.mm,
          horaInicio: this.datosFormulario.horaInicio.HH + this.datosFormulario.horaInicio.mm,
          idEstatusListaEspera: 1,
          idClinica: this.$localStorageService.getIdClinica(),
          idEmpleado:this.datosFormulario.idDoctor,
          idEspecialidad: this.datosFormulario.idEspecialidad,
          idTratamiento: this.datosFormulario.idTratamiento,
          diasExclusion: this.datosFormulario.dias === undefined || this.datosFormulario.dias === null ? [] : this.datosFormulario.dias,
          procesoManual: true,
          idTagMotivoCita: this.datosFormulario.idTagMotivoCita,
        };
      this.$emit('guardarListaEsperaDatos', datos, true)
    },
    filtroDoctores(busqueda, loading) {
      loading(true);
      let seach = busqueda.trim();
      this.listaDoctoresFiltro = this.listaDoctores.filter((em) => {
        return em.nombre.toLowerCase().includes(seach.toLowerCase());
      });
      loading(false);
    },
    setearPaciente(item) {
      this.datosFormulario.idPaciente = item.id;
      this.datosFormulario.nombrePaciente = item.name;
      this.datosFormulario.esPacienteNuevo = item.esPacienteNuevo;
      this.datosFormulario.indicadorProbabilidad = item.indicadorProbabilidad;
      this.datosFormulario.telefono = item.telefono;
      this.datosFormulario.correo = item.correo;
      this.datosFormulario.esPacienteVIP = item.esPacienteVIP;

      this.idTagMotivoCita = undefined;
      this.datosFormulario.idTratamiento = undefined;
      this.datosFormulario.nombreTratamiento =
          "--Primero selecciona un motivo--";

      window.scrollTo(0, 0);
      this.$emit('tagMotivoCita');
    },
    esLetra(e) {
      let char = String.fromCharCode(e.keyCode);
      if (/^[A-Za-zÁÉÍÓÚáéíóúñÑ\s]+$/.test(char)) return true;
      else e.preventDefault();
    },


    getPatientsV2() {
      if ( (this.nombre != undefined && this.nombre.length >= 3) || (this.apellidoPaterno != undefined && this.apellidoPaterno.length >= 3) || (this.apellidoMaterno != undefined && this.apellidoMaterno.length >= 3)) {

        this.loadingPacientes = true;
        this.$http
            .get(
                this.$api +
                "paciente/perfiles/obtenerDatosPacienteAgenda?nombre=" +
                this.nombre.trim() + "&apellidoPaterno=" + this.apellidoPaterno.trim() + "&apellidoMaterno=" + this.apellidoMaterno.trim()
            )
            .then((response) => {
              if (response.status === 200) {


                if (Array.isArray(response.data.data)) {
                  const uniqueAddresses = Array.from(
                      new Set(response.data.data.map((a) => a.id))
                  ).map((id) => {
                    return response.data.data.find((a) => a.id === id);
                  });
                  uniqueAddresses.map((elementDos) => {

                    var data = {
                      id: elementDos.id,
                      name: elementDos.nombre,
                      esPacienteNuevo: elementDos.esPacienteNuevo,
                      indicadorProbabilidad: elementDos.indicadorProbabilidad,
                      correo: elementDos.correo,
                      telefono: elementDos.telefono
                    };
                    this.listaPacientes.push(data);
                    return data;
                  });

                  if (Array.isArray(this.listaPacientes)) {
                    this.listaPacientes.sort(function (a, b) {
                      if (a.id > b.id) {
                        return 1;
                      }
                      if (a.id < b.id) {
                        return -1;
                      }
                      return 0;
                    });
                  }
                }
              }
            })
            .catch((error) => {
              miniToastr.info("No se encontraron pacientes");
              console.error("Error", error);
              this.loadingPacientes = false;
            })
            .finally(() => {
              this.loadingPacientes = false;
            });
        return this.listaPacientes;
      }
    },



    setearMotivoTag(item) {
      if (this.datosFormulario.esPacienteNuevo) {
        const datos = JSON.parse(JSON.stringify(this.tagmotivocitaDatosArray));
        const tratamientos = datos.filter((it) => it.idTagMotivoCita === item);
        if (tratamientos !== undefined && tratamientos[0] !== undefined) {
          this.datosFormulario.idTratamiento = tratamientos[0].idTratamiento;
          this.datosFormulario.nombreTratamiento =
              tratamientos[0].nombreTratamiento.toUpperCase();
        }
      }
    },
  },
}
</script>

<style scoped>
.centrar {
  display: flex;
  justify-content: center;
}
</style>
